import { filter } from 'rxjs/operators';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig
} from '@angular/material/legacy-dialog';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { HeaderService } from '../../header.services';
import { BrowserService } from '../../browser.service';
import { NavigationEnd, Router } from '@angular/router';
import { RegionService } from '../../services/region.service';
import { Unsubscriber } from '../../unsubscriber/unsubscriber';
import { IOfferRegionListItem } from '../../models/offer-region';
import { environment } from './../../../../environments/environment';
import { SubscribeDialogComponent } from '../../../shared/modals/subscribe-dialog/subscribe-dialog.component';

@Component({
  selector: 'brf-news-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends Unsubscriber implements OnInit {
  searchField = new UntypedFormControl();
  mobileView = false;
  shouldShowHeader = true;
  showListRegion = false;
  isNewsCategory: boolean = false;
  loginUrl: string = '/organisation/marketing/dashboard/news';
  allRegions: IOfferRegionListItem[];

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private regionService: RegionService,
    private browserService: BrowserService,
    private headerService: HeaderService
  ) {
    super();
    this.loginUrl = environment.brfDashboard + this.loginUrl;
    this.addSubscription(this.browserService.isMobileScreenSubject.subscribe(flag => (this.mobileView = flag)));
  }

  ngOnInit(): void {
    if (this.browserService.isbrowser) {
      this.addSubscription(
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(e => {
          this.isNewsCategory =
            location.pathname === '/' || location.pathname === '/nyheter' || location.pathname.startsWith('/nyheter/');
        })
      );

      this.addSubscription(
        this.regionService.getAllSwedishRegions().subscribe(data => {
          this.allRegions = data;
        })
      );
    }

    this.addSubscription(
      this.headerService.showHeaderSubject.subscribe(flag => {
        this.shouldShowHeader = flag;
      })
    );
  }

  search() {
    const obj = { keyword: this.searchField.value };
    this.router.navigateByUrl('/search', { state: obj });
  }

  openSubscribeModal() {
    const dialogConfig = new MatDialogConfig();
    //dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.maxHeight = '100vh';
    dialogConfig.data = {};
    this.dialog.open(SubscribeDialogComponent, dialogConfig);
  }

  checkReloadPage() {
    if (this.router.url == '/') {
      location.reload();
    }
  }

  // goToLogin() {
  //   if (this.browserervice.isbrowser) {
  //     setTimeout(() => {
  //       window.open(this.loginUrl, '_blank');
  //     });
  //   }
  // }
}
